const EXPLAINERS = Object.freeze({
  SHAPE_HAS_ASSOCIATED_ITEMS: "Whoa boss. Looks like there are items associated with this shape. I can't delete it before the items are deleted too."
});
export function explainError({
  extensions
} = {}) {
  return EXPLAINERS[extensions === null || extensions === void 0 ? void 0 : extensions.code];
}